import {
	getContentLanguageTag,
	getPrimaryHreflangChannel,
	isRegionalLocale,
	isValidLocale,
	type Locale,
} from "@/config/locale";

/**
 * `lang` and JSON-LD `inLanguage` of text a regional route shows from another locale (spec 5.5):
 * es-mx showing es text → "es". Undefined for the route's own text, for an unknown source and
 * on every non-regional route, whose markup therefore stays unchanged. Shared by every surface
 * with a regional fallback (products, categories, lexicon, guides, comparisons, calculators).
 */
export function getFallbackTextLanguage(
	routeLocale: Locale,
	sourceLocale: string | null | undefined,
): string | undefined {
	if (!isRegionalLocale(routeLocale) || !sourceLocale || sourceLocale === routeLocale) return undefined;
	if (!isValidLocale(sourceLocale)) return undefined;
	return getContentLanguageTag(sourceLocale, getPrimaryHreflangChannel(sourceLocale));
}
